var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5091 9.72189L13.0085 2.9029C12.7329 2.65063 12.3729 2.51072 11.9994 2.51074C11.6258 2.51077 11.2658 2.65073 10.9904 2.90304L3.491 9.72184C3.33649 9.86254 3.21302 10.0339 3.12848 10.225C3.04394 10.4161 3.00018 10.6228 3 10.8317V19.4999C3 19.6969 3.0388 19.892 3.1142 20.074C3.18959 20.256 3.3001 20.4213 3.4394 20.5606C3.57871 20.6999 3.74409 20.8104 3.9261 20.8858C4.10811 20.9611 4.30319 20.9999 4.50019 20.9999L8.99955 20.9992C9.19844 20.9992 9.38919 20.9202 9.52982 20.7795C9.67045 20.6389 9.74946 20.4481 9.74945 20.2492V14.2492H14.2495V20.2492C14.2495 20.4481 14.3285 20.6389 14.4691 20.7795C14.6097 20.9202 14.8005 20.9992 14.9994 20.9992L19.4998 20.9999H19.5C19.697 20.9999 19.892 20.9611 20.074 20.8857C20.256 20.8103 20.4214 20.6999 20.5607 20.5606C20.6999 20.4213 20.8104 20.2559 20.8858 20.0739C20.9612 19.8919 21 19.6969 21 19.4999V10.8318C20.9998 10.6228 20.956 10.4162 20.8715 10.2251C20.787 10.034 20.6636 9.86261 20.5091 9.72189Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboardIcon.d3e4fa60594cacfc3412e9ada6f2ac6f.svg";
export { ForwardRef as ReactComponent };